export default "__VITE_ASSET__4094935f__"